import { humanizeStatus } from '@/shared/utils/statusComunicacao';

import type { EventoRcsCertificadoDto } from '../types/certificadoAcessosDto';
import type {
  GrauRcsCertificado,
  VarianteStatusCertificado,
} from '../types/certificadoAcessosTypes';

/**
 * Régua própria do RCS, e não a do WhatsApp: no cartão RCS a leitura é só indício (o aparelho
 * avisa que abriu, não quem leu), e o que cita é o clique no botão "Acessar o processo". Herdar
 * `StatusWhatsApp` pintaria de verde o "RCS lido" — uma ciência que o core não reconhece.
 */
const GRAUS_RCS: Record<EventoRcsCertificadoDto, GrauRcsCertificado> = {
  ENVIADO: { rotulo: 'Cartão RCS enviado', variante: 'warning' },
  ENTREGUE: { rotulo: 'RCS entregue', variante: 'warning' },
  VISUALIZADO: { rotulo: 'RCS lido', variante: 'warning' },
  CLICKED: { rotulo: 'Clique em Acessar o processo', variante: 'success' },
  REPLIED: { rotulo: 'Respondeu ao cartão RCS', variante: 'warning' },
  FALHA: { rotulo: 'Falha no RCS', variante: 'error' },
};

function ehStatusRcsConhecido(status: string): status is EventoRcsCertificadoDto {
  // `Object.hasOwn`: `'toString' in GRAUS_RCS` acharia a função herdada do protótipo.
  return Object.hasOwn(GRAUS_RCS, status);
}

/**
 * Grau desconhecido passa pelo tradutor genérico dos status de envio, como os outros canais
 * digitais: o rótulo amigável vale só para o que o front sabe o que significa.
 */
export function rotuloStatusRcs(status: string): string {
  return ehStatusRcsConhecido(status) ? GRAUS_RCS[status].rotulo : humanizeStatus(status);
}

/** `undefined` para grau desconhecido: quem chama decide o tom, como faz com os outros canais. */
export function varianteStatusRcs(status: string): VarianteStatusCertificado | undefined {
  return ehStatusRcsConhecido(status) ? GRAUS_RCS[status].variante : undefined;
}
